import Constants from './Constants.js'

export default () => {
  const width = window.innerWidth

  if (width < Constants.breakpoints.sm) {
    return 'xs'
  } else if (width < Constants.breakpoints.md) {
    return 'sm'
  } else if (width < Constants.breakpoints.mdl) {
    return 'md'
  } else if (width < Constants.breakpoints.lg) {
    return 'mdl'
  } else if (width < Constants.breakpoints.xl) {
    return 'lg'
  } else if (width < Constants.breakpoints.xxl) {
    return 'xl'
  } else {
    return 'xxl'
  }
}
